export class PeriodoAtividade {
  id: number;
  nome: string;
  descricao: string;
  idInstituicao: number;
  usuarioAlteracao: number;
}
